import { Component, OnInit } from '@angular/core';
import { AuthService } from '../shared/auth.service';
import { Router } from '@angular/router';
import { Role } from '../shared/Roles';
import { AccountServiceProxy } from '../service-proxies';
import { ProfilePictureService } from '../shared/utils/profile-picture.service';
import { AppTranslationService } from '../shared/app-translation.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  logo = 'assets/img/newlogo.png';
  profilePicture: string;
  isLoggedin = false;
  userName: string;
  role = Role;
  constructor(private _authService: AuthService,
    private _account: AccountServiceProxy,
    private _languageService: AppTranslationService,
    private _profile:ProfilePictureService,
    private _SpinnerService:NgxSpinnerService) { }

  ngOnInit() {
    this.profilePicture =  'assets/img/default-profile-picture.png';
    this.isLoggedin = this._authService.isLoggedIn;
    if (this.isLoggedin) {
      this.userName = this._authService.currentUserName;
      this.getProfilePicture();
    }
    this._profile.changeEvent.subscribe(result => {
      this.getProfilePicture();
    });
  }

  getProfilePicture() {
    this._account.getUserProfilePicture(this._authService.userId).subscribe(result => {
      if (result.profilePicture) {
        this.profilePicture = 'data:image/jpeg;base64,' + result.profilePicture;
      } else {
        this.profilePicture =  'assets/img/default-profile-picture.png';
      }
    });
  }

  changeLanguage(lang: string) {
    this._authService.setLanguage(lang);
    window.location.reload();
  }

  logout() {
    this._SpinnerService.show();
    this._authService.logout();
  }

  get userRole(): string {
    return this._authService.userRole.toLowerCase();
  }

  isGranted(role: string): boolean {
    if (this._authService.userRole.toLowerCase() === role.toLowerCase()) {
      return true;
    } else {
      return false;
    }
  }

}
